module.exports = __webpack_public_path__ + "img/skearLogo2020-sm-min.c7c906fe.png";